module.exports = __webpack_public_path__ + "img/gender_female.fdb99669.svg";